import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './OptionsForm.css';
import cx from 'classnames';

const options = [];

class OptionsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: true,
    };
  }

  toggleCollapse = () => {
    this.setState(prevState => ({
      collapsed: !prevState.collapsed,
    }));
  };

  render() {
    const { selectedColors, selectColor } = this.props;
    const { collapsed } = this.state;

    const classname = cx(s.root, {
      [s.collapsed]: collapsed,
    });

    return (
      <div className={classname} />
    );
  }
}

OptionsForm.propTypes = {
  selectColor: PropTypes.func,
};

OptionsForm.defaultProps = {
  selectColor: f => f,
};

export default withStyles(s)(OptionsForm);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanel/OptionsForm/OptionsForm.js